module.exports = __webpack_public_path__ + "static/img/5.1.7433a26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/5.1.png
// module id = u5kC
// module chunks = 0